import React from 'react'
import { Button, Modal, Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch, connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { thunks as AuthThunks } from 'reducers/Auth'
import PlayerActions from 'reducers/Player'
import ModalActions from 'reducers/Modal'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import { XButtonWrapper, ButtonWrapper } from './SignoutModal.styles'
import { Close } from '@dsny/dsny-component-library/icons'
import { StyledModal } from '../Modals.styles'
import { trackEvent } from 'utils/segmentService'

const mapStateToProps = ({ modal }) => ({
  showSignoutModal: modal?.showSignoutModal
})

function SignoutModal({ showSignoutModal }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()

  const handleCancelButtonClick = () => {
    dispatch(ModalActions.toggleSignoutModal())
  }

  const handleLogoutButtonClick = () => {
    navigate('/')
    dispatch(AuthThunks.logout())
    dispatch(ModalActions.toggleSignoutModal())
    dispatch(PlayerActions.updatePlayerState(false))
  }

  return (
    <StyledModal
      isOpen={showSignoutModal}
      onClose={handleCancelButtonClick}
      $isMobile={isMobile}
      analyticsModalType="signout"
      trackEvent={trackEvent}
      containerStyles={{
        padding: isMobile ? '24px 12px' : '72px 64px'
      }}
    >
      {!isMobile && (
        <XButtonWrapper onClick={handleCancelButtonClick}>
          <Close width={24} height={24} color={theme.colors.neutralW80} />
        </XButtonWrapper>
      )}

      <Tonality.UIHeading
        headingStyle="headline5"
        color={theme.colors.neutralW90}
        style={{ lineHeight: 2 }}
      >
        {t('sidebar.sign-out-modal-title')}
      </Tonality.UIHeading>

      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW70}
        style={{ fontSize: 14, marginBottom: 16 }}
      >
        {t('sidebar.sign-out-modal-body')}
      </Tonality.UIText>

      <ButtonWrapper>
        <Button
          variant="primary"
          setting="player"
          mode="dark"
          style={{ marginBottom: 16 }}
          onClick={handleLogoutButtonClick}
        >
          {t('sidebar.sign-me-out')}
        </Button>
        <Button
          variant="secondary"
          setting="player"
          mode="dark"
          onClick={handleCancelButtonClick}
        >
          {t('general.cancel')}
        </Button>
      </ButtonWrapper>
    </StyledModal>
  )
}

export default connect(mapStateToProps)(SignoutModal)
